module.exports = __webpack_public_path__ + "img/de-praktijk-5.b0d1c8d5.jpg";